<template>
  <div id="page-wrap">
    <div class="container-fluid group-wrap clearfix">
      <div class="container">
        <div class="group-header">
          <div class="group-avator">
            <img
              class="group_logo"
              :src="groupInfo.group_logo ? groupInfo.group_logo : errorImg"
            />
          </div>
          <div class="name">
            <h1>{{ groupInfo.group_name }}</h1>
          </div>
          <div class="info">
            <p>
              <span>类型：{{ groupInfo.group_category_name }}</span>
              <span>群主：{{ groupInfo.group_owner_name }}</span>
              <span
                >创建时间：{{ groupInfo.group_created_date | cutTime }}</span
              >
            </p>
            <p>
              <span>群组简介：{{ groupInfo.group_description }}</span>
            </p>
          </div>
          <div class="button-container">
            <a
              class="btn-group-plus"
              data-target="#applygroup"
              data-toggle="modal"
              v-if="right__groupApply && !isMember"
            >
              <i class="iconfont icon-group-plus"></i>
              申请加入
            </a>
            <a
              class="btn-group-plus"
              data-target="#applyrole"
              data-toggle="modal"
              v-if="hasManageGroupRolePermission"
            >
              <i class="ti-settings"></i>
              群角色设置
            </a>
            <router-link class="btn-group-plus" :to="{ name: 'grouplist' }">
              <i class="iconfont icon-mygroup"></i>
              我的群组
            </router-link>
          </div>
        </div>
        <div class="group-tabs-header clearfix">
          <ul class="nav nav-tabs group-tabs pull-left">
            <router-link :to="{ name: 'group' }" tag="li">
              <a>主页</a>
            </router-link>
            <router-link :to="{ name: 'groupMember' }" tag="li">
              <a>成员</a>
            </router-link>
            <router-link :to="{ name: 'groupTopic' }" tag="li">
              <a>话题</a>
            </router-link>
            <router-link :to="{ name: 'groupDisk' }" tag="li" v-if="isMember">
              <a>群盘</a>
            </router-link>
          </ul>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="tab-content clearfix" v-if="showPanel">
        <div class="tab-pane fade in active">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <GroupApply :group_number="groupNumber"></GroupApply>
    <GroupRole :group_number="groupNumber"></GroupRole>
  </div>
</template>

<script>
const errorImg = require("@/assets/images/group_avator.png");
export default {
  name: "GroupWraper",
  components: {
    GroupApply: () => import("./GroupApply"),
    GroupRole: () => import("./GroupRole"),
  },
  data() {
    return {
      errorImg: errorImg,
      groupNumber: null,
      showPanel: false,
    };
  },
  created() {
    this.groupNumber = this.$route.params.groupNumber;
    this.$store.commit("SET_THEME", "群组");
    this.getGroupPublicInfo();
  },
  watch: {
    $route(to) {
      this.groupNumber = to.params.groupNumber;
      this.getGroupPublicInfo();
    },
  },
  computed: {
    right__groupApply () {
      return this.$store.getters.right__groupApply
    },
    isMember() {
      return this.$store.state.group.isMember;
    },
    groupInfo() {
      return this.$store.state.group.groupInfo;
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
    // 设置群角色
    hasManageGroupRolePermission() {
      return (
        this.groupInfo.group_member_identity === "owner" ||
        this.permissions.public_operations.indexOf("manageGroupRole") > -1
      );
    },
  },
  filters: {
    cutTime(value) {
      if (value) {
        return value.slice(0, 10);
      }
    },
  },
  methods: {
    goToUser(userNumber) {
      let routeUrl = this.$router.resolve({
        name: "user",
        params: { userNumber: userNumber },
      });
      window.open(routeUrl.href, "_blank");
    },
    getGroupPublicInfo() {
      this.$store
        .dispatch("getGroupPublicInfo", this.groupNumber)
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setGroup", res.entity);
            if (this.$route.name === "groupDisk") {
              let isMember =
                ["owner", "admin", "user"].indexOf(
                  res.entity.group_member_identity
                ) > -1;
              if (!isMember) {
                this.$message({
                  type: "warning",
                  message: "您不是群成员，无权限访问群盘",
                });
                setTimeout(() => {
                  this.$router.push({ name: "grouplist" });
                }, 3000);
              } else {
                this.showPanel = true;
              }
            } else {
              this.showPanel = true;
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
            setTimeout(() => {
              this.$router.push({ name: "grouplist" });
            }, 3000);
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
          setTimeout(() => {
            this.$router.push({ name: "grouplist" });
          }, 3000);
        });
    },
  },
};
</script>

<style scoped>
.nav-tabs > li.router-link-active > a {
  color: #006adf;
  cursor: default;
  background-color: #f9f9f9;
  border-bottom-color: transparent;
}
.group_logo {
  width: 80px;
  height: 80px;
}
.newuser-box {
  width: 350px;
  position: relative;
  z-index: 100;
}

.newuser-box .form-control ~ i {
  width: 36px;
  height: 36px;
  font-size: 12px;
  color: #999;
  z-index: 10;
  position: absolute;
  top: 0;
  right: 0px;
  text-align: center;
  line-height: 36px;
}
.newuser-box .cont {
  width: 100%;
  position: absolute;
  top: 35px;
  left: 0;
  background: #fff;
  border: #e1e1e1 solid 1px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 5px 10px;
}
.newuser-box .cont li {
  width: 100%;
  padding: 15px 10px;
  float: left;
  border-bottom: #e1e1e1 solid 1px;
}
.newuser-box .cont li .avator {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  /* background-image: url(../../assets/images/avator.svg); */
  background-size: 30px;
  background-color: #fff;
  float: left;
}
.newuser-box .cont li .avator img {
  vertical-align: inherit;
}
.newuser-box .cont li:hover {
  background: #f9f9f9;
  cursor: pointer;
}
.newuser-box .cont li:last-child {
  border-bottom: none;
}
.newuser-box .cont li p {
  float: left;
  line-height: 30px;
  padding-left: 10px;
}
.newuser-box .cont li a {
  float: right;
  background: #006adf;
  line-height: 30px;
  color: #fff;
  padding: 0px 10px;
  height: 30px;
  display: block;
}
.newuser-box .form-control:valid ~ .cont {
  display: block;
}
.newuser-box .form-control:valid ~ i {
  display: block;
}
.newuser-box .cont li a:hover {
  background: #0052ac;
}
.bg-gray {
  background: #31b0d5 !important;
}
</style>